var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card 1",
    clipPath: "url(#clip0_1615_16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_Card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Red_x5F_Circle",
    d: "M8.125 16C12.6123 16 16.25 12.4183 16.25 8C16.25 3.58172 12.6123 0 8.125 0C3.63769 0 0 3.58172 0 8C0 12.4183 3.63769 16 8.125 16Z",
    fill: "#F93232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Yellow_x5F_Circle",
    d: "M17.875 0C16.0501 0 14.3715 0.6 13.0163 1.6H13V1.6112C12.6783 1.8496 12.3825 2.1184 12.1006 2.4H13.8994C14.1497 2.6504 14.3804 2.9184 14.5941 3.2H11.3994C11.2027 3.4552 11.0224 3.7216 10.8574 4H15.1344C15.2872 4.2592 15.431 4.5232 15.5553 4.8H10.4439C10.3277 5.06 10.2253 5.3264 10.1376 5.6H15.8608C15.9453 5.8608 16.0119 6.1288 16.0704 6.4H9.9255C9.87106 6.6624 9.82556 6.928 9.79794 7.2H16.2013C16.2329 7.4624 16.25 7.7288 16.25 8H9.75C9.75 8.2712 9.77194 8.536 9.79875 8.8H16.2029C16.172 9.0712 16.1273 9.3376 16.0713 9.6H9.92631C9.98238 9.8728 10.0547 10.1384 10.1384 10.4H15.8616C15.7739 10.6736 15.6715 10.94 15.5553 11.2H10.4439C10.5666 11.4752 10.7047 11.7424 10.8574 12H15.1344C14.9703 12.2784 14.7875 12.5448 14.5909 12.8H11.3994C11.6155 13.0816 11.8487 13.3496 12.0998 13.6H13.8994C13.6167 13.8824 13.3217 14.1504 13 14.3888C14.3585 15.396 16.0428 16 17.875 16C22.3624 16 26 12.4176 26 8C26 3.5824 22.3624 0 17.875 0Z",
    fill: "#FED049"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card 1.15e89dcdd0c593d8bfc3bea0ee97a784.svg";
export { ForwardRef as ReactComponent };